import {
  iconLocationMarker,
  iconRoundsMarker,
  iconStartMarker,
  iconEndMarker,
  iconPauseMarker,
  iconWaypointMarker,
} from "~/js/Views/Map/Maps/Google/MapSymbols";
import { SPLITS_MAPPING } from "~/js/Views/Track/Parser/ParserWrapperConstants";
import { getTrackStatistics } from "~/js/utilities/calculations/trackStatistics/getTrackStatistics";
import { calculateUserStats } from "~/js/utilities/calculations/calculateUserStats";
import { getActivityDetails } from "~/js/config/activityMapping";
import { enrichTrackPoints } from "~/js/utilities/calculations/enrichTrackPoints";

export const prettifyName = (str) => {
  if (!str) return "";
  // Remove the file extension
  let cleanedStr = str.replace(/\.(gpx|tcx)$/i, "");

  // Replace underscores and hyphens with spaces
  cleanedStr = cleanedStr.replace(/[_-]/g, " ");

  // Handle camelCase: insert space before capital letters if preceded by lowercase
  cleanedStr = cleanedStr.replace(/([a-z])([A-Z])/g, "$1 $2");
  const prettyString = cleanedStr
    .split(/\s+/) // Split by any whitespace
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ")
    .trim();
  return prettyString;
};

export const buildTrackData = (track, profile, isReversed = false) => {
  if (!track) return null;

  let trackPoints = [...track.points.points];
  if (isReversed) {
    trackPoints = trackPoints.reverse();
  }

  // Enrich track points with additional data (e.g. slope, cumulative distance)
  // This is done here to allow runtime updates without re-importing
  trackPoints = enrichTrackPoints(trackPoints);

  const trackStats = getTrackStatistics(trackPoints);
  trackStats.points.track = trackPoints;

  const trackData = {
    points: trackStats.points,
    stats: trackStats.statistics,
    spatial: trackStats.spatial,
    id: track.id,
    symbols: {
      center: iconLocationMarker,
      stops: iconPauseMarker,
      wayPoints: iconWaypointMarker,
    },
    file: track.file,
    bounds: track.points.bounds,
    marker: {
      start: {
        id: "startMarker",
        lat: trackPoints[0].lat,
        lng: trackPoints[0].lng,
        icon: encodeURI("data:image/svg+xml;utf8," + iconStartMarker),

        label: "S",
      },
      end: {
        id: "endMarker",
        lat: trackPoints[trackPoints.length - 1].lat,
        lng: trackPoints[trackPoints.length - 1].lng,
        icon: encodeURI("data:image/svg+xml;utf8," + iconEndMarker),

        label: "E",
      },
    },
    wayPoints: {
      id: "wayPoints",
      marker: track.marker.wayPoints,
      icon: encodeURI("data:image/svg+xml;utf8," + iconWaypointMarker),
    },
    stops: {
      id: "stops",
      marker: trackStats.points.stops,
      icon: encodeURI("data:image/svg+xml;utf8," + iconPauseMarker),
    },
    splits: SPLITS_MAPPING.map((splitItem) =>
      splitItem.split < trackStats.splits.length
        ? {
            id: "splits" + splitItem.split,
            marker: trackStats.splits[splitItem.split],
            icon: encodeURI("data:image/svg+xml;utf8," + iconRoundsMarker),
            labelKey: "distance.cumulativeKm",
            label: splitItem.label,
            zoom: splitItem.zoom,
            split: splitItem.split,
          }
        : false,
    ).filter(Boolean),
  };

  // *** check for existing track infos
  trackData.info = { ...track.info }; // Create a copy to avoid mutating original

  if (trackData.info.type) {
    trackData.info.originalType = trackData.info.type;
    const activityDetails = getActivityDetails(trackData.info.type);
    trackData.info.type = activityDetails.id;
  }

  /*   if (!trackData.info.name || trackData.info.name.includes("_")) {
    const sourceString = trackData.info.name || trackData.file.fileName;
    trackData.info.name = prettifyName(sourceString);
  } */
  const sourceString = trackData.info.name || trackData.file.fileName;
  trackData.info.name = prettifyName(sourceString);

  trackData.ui = {
    navigation: ["statistics", "activities"],
  };

  if ("wayPoints" in trackData && trackData.wayPoints.marker.length) {
    trackData.ui.navigation.push("wayPoints");
  }
  if ("stops" in trackData && trackData.stops.marker.length > 0) {
    trackData.ui.navigation.push("stops");
  }
  if (trackData.splits.length) {
    trackData.ui.navigation.push("splits");
  }

  const firstPoint = trackPoints[0];
  console.log("trackData", trackData.stats);
  if (
    trackData.stats.elevation.ascent !== 0 ||
    firstPoint.heartrate !== null ||
    firstPoint.time !== null
  ) {
    trackData.ui.navigation.push("trackProfiles");
  }

  const userStats = calculateUserStats(profile, {
    duration: trackStats.statistics.duration.total,
    distance: trackStats.statistics.distance.total,
    heartrate: trackStats.statistics.heartrate.average,
  });

  trackData.stats.user = userStats;
  return trackData;
};
